import Typography from '@mui/material/Typography'
import { RegularSection, SwiperV2, ColorTitle } from '@/components/Layouts'

interface Card {
    title?: string
    subtitle?: string
    description?: string
}

interface Content {
    title?: string
    subtitle?: string
    cards?: Card[]
}

interface S2_Hero_5Props {
    content?: Content
    blockName?:string
}

const Index = (props: S2_Hero_5Props) => {
    const { content = {} } = props
    const { title, subtitle, cards = [] } = content
    return (
        <RegularSection aria-label='S2_Hero_5' >

            <ColorTitle title={title} colorFrom={0}/>
            <Typography
                variant='body2'
                sx={{ textAlign: 'center', width: { xs: '90vw', md: '80vw' } }}
            >
                {subtitle}
            </Typography>
            <SwiperV2 cards={cards}/>
        </RegularSection>
    )
}

export default Index
